// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JYzd","type":"styles_type__iL0b8","choices":"styles_choices__3cjKL"};